import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-admin';
import CardMedia from '@material-ui/core/CardMedia';

const style = theme => ({
    card: {
        flex: '1',
        marginLeft: '1em',
        maxHeight: 440,
    },
    list: {
        flex: '1',
        overflow: 'auto',
        maxHeight: 357,
    },
});

const ErrorResources = ({ resources = [], total, translate, classes }) => (
    <Card className={classes.card}>
        <CardHeader title={translate('dashboard.errorResources.title')} subheader={translate('dashboard.errorResources.subheader') + `（${total ? total : 0}` + translate('dashboard.disconnectedResources.unit') + `）`} />
        <CardMedia className={classes.list}>
            <List>
                {resources.map(record => (
                    <ListItem>
                        <ListItemText
                            primary={`${record.name}`}
                            className={classes.listItemText}
                        />
                    </ListItem>
                ))}
            </List>
        </CardMedia>
    </Card>
    
);

const enhance = compose(
    withStyles(style),
    translate
);

export default enhance(ErrorResources);